"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateActivityImage = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var service_1 = require("../../../library/base/service");
var inviteActivity_1 = require("../../model/inviteActivity");
var UpdateActivityImage = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UpdateActivityImage, _super);
    function UpdateActivityImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'h5分享页面图片上传';
        _this.code = '300415';
        _this.desc = 'h5分享页面图片上传';
        _this.requestParams = new inviteActivity_1.UpdateActivityImageRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UpdateActivityImage;
}(service_1.BaseService));
exports.UpdateActivityImage = UpdateActivityImage;
//# sourceMappingURL=updateActivityImage.js.map